import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import styled from 'styled-components';
import { useFocus } from '../../hooks/use_focus.js';
import { bindRefs } from '../../utils/react.js';
import { getContainerStyles } from '../Input/InputContainer.js';
import { getInputStyles } from '../Input/InputInput.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["onBlur", "onFocus"];
var StyledTextarea = styled.textarea.withConfig({
  displayName: "Textarea__StyledTextarea",
  componentId: "sc-13ttplf-0"
})(function (props) {
  return _objectSpread(_objectSpread({}, getInputStyles(props)), getContainerStyles(props));
});
var Textarea = /*#__PURE__*/React.forwardRef(function Component(props, ref) {
  var onBlur = props.onBlur,
    onFocus = props.onFocus,
    inputProps = _objectWithoutProperties(props, _excluded);
  var _useFocus = useFocus({
      disabled: props.disabled,
      onFocus: onFocus,
      onBlur: onBlur
    }),
    focused = _useFocus.focused,
    handleBlur = _useFocus.handleBlur,
    handleFocus = _useFocus.handleFocus,
    inputRef = _useFocus.inputRef;
  return /*#__PURE__*/jsx("div", {
    className: "_mntl-textarea mntl-outline-focus-within",
    children: /*#__PURE__*/jsx(StyledTextarea, _objectSpread(_objectSpread({}, inputProps), {}, {
      focused: focused,
      onBlur: handleBlur,
      onFocus: handleFocus,
      ref: bindRefs(inputRef, ref)
    }))
  });
});
Textarea.displayName = "Textarea";

export { Textarea };
